import React from 'react';
import AsyncSelect from 'react-select/async';
import { useFormContext, Controller } from "react-hook-form";
import { useTheme } from '@material-ui/core/styles';

import * as RemindersApi from '../../../../../Common/Apis/RemindersApi';
import { IAsset } from "../../../store/ReminderStore";

interface IProps {
  readOnly: boolean;
  assetInfoBind: (assetInfo: IAssetInfo) => void;
}

export interface IAssetInfo {
  make: string,
  model: string,
  year: string,
  vin: string,
  odometer: string
}

const AssetList = ({ readOnly, assetInfoBind }: IProps) => {
  const pageSzie = 200;
  const pageNo = 1;

  const theme = useTheme();

  const colourStylesForSelect = {
    control: (styles: any, state: any) => ({
      ...styles,
      boxShadow: state.isFocused
        ? `0 0 0 0.1rem ${theme.palette.primary.main}4d`
        : 0,
      // boxShadow: `0 0 0 0.1rem ${theme.palette.primary.main}4d`,
      borderColor: state.isFocused ? theme.palette.primary.main : '#CED4DA',
      '&:hover': {
        borderColor: state.isFocused ? theme.palette.primary.main : '#CED4DA',
      },
    }),
  };

  const { control, setValue } = useFormContext();

  const loadOptions = async (inputValue: string) => {

    try {

      const resData = await RemindersApi.getAssetSearchList(inputValue, pageNo, pageSzie);

      console.log("resData", resData);

      const dataOptions = resData.Data.map((asset: IAsset) => (
        {
          label: asset.PlateNumber + "-" + asset.Code,
          value: asset.Id,
          otherValues: {
            make: asset.Make,
            model: asset.Model,
            year: asset.YearOfManufacture,
            vin: asset.Vin,
            odometer: asset.OdometerKm
          }
        }
      ));

      return dataOptions;

    } catch (err) {
      console.log('err', err);
    }

    return [];
  };

  const handleChange = (data: any) => {

    const assetInfo: IAssetInfo = {
      make: data?.otherValues?.make ?? "",
      model: data?.otherValues?.model ?? "",
      year: data?.otherValues?.year ?? "",
      vin: data?.otherValues?.vin ?? "",
      odometer: data?.otherValues?.odometer ?? "",
    };
    assetInfoBind(assetInfo);

    if (data) {
      setValue("asset", data);
      setValue("assetId", data.value);


    }
    else {
      setValue("asset", "");
      setValue("assetId", "");
    }
  };

  return (
    <Controller
      name="asset"
      rules={{ required: true, validate: (v) => v.value !== "" }}
      control={control}
      render={({ field }) =>
        <AsyncSelect
          {...field}

          placeholder="Select asset"
          styles={colourStylesForSelect}
          cacheOptions
          isClearable={true}
          loadOptions={loadOptions}
          onChange={handleChange}
          isDisabled={readOnly}

        />}
    />
  );

};


export default AssetList;